export default function getArticleChannelData(article, channelId, key) {
	return article?.channels?.[channelId]?.[key]?.length > 0
		? article.channels[channelId][key]
		: article?.[key] || article?.channels?.[channelId]?.[key];
}
